<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">普客工作汇报</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <FilterCommon :model="filterModel" :isAdd="true" :isReset="true" :isExp="true" @add="add" @search="search" @reset="reset" @exp="exp">
              <template v-slot:button>
                <el-button type="primary" @click="handleClickLeadIn">导入</el-button>
              </template>
            </FilterCommon>
            <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000">
              <el-table-column prop="duty_type_name" label="班次"  />
              <el-table-column prop="created_date" label="提交时间" />
              <el-table-column prop="admin_name" label="普客客服"  />
              <el-table-column prop="nickname" label="账号昵称" />
              <el-table-column label="操作" width="250">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                  <el-popover placement="top" width="160" v-model="scope.row.deleteVisible">
                    <p>确定删除吗？</p>
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" type="text" @click="scope.row.deleteVisible = false">取消</el-button>
                      <el-button type="primary" size="mini" @click="del(scope.row)">确定</el-button>
                    </div>
                    <el-button slot="reference" size="mini" type="danger">删除</el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="total > 0" :total="total" :page.sync="searchParams.page" :limit.sync="searchParams.limit" @pagination="getTableList" />
            <!-- 添加弹窗 -->
            <Dialog
              ref="dialog"
              :dialogTitle="dialogTitle"
              :dialogVisible="dialogVisible"
              :dialogModel="dialogModel"
              :rules="rules"
              dialogWidth="700px"
              @submitForm="handleSubmit"
              @closeDialog="closeDialog"
            />
            <!-- 查看弹窗 -->
            <Dialog
              ref="remarkDialog"
              :dialogTitle="'备注'"
              :dialogVisible="remarkVisible"
              :dialogModel="remarkModel"
              dialogWidth="700px"
              @closeDialog="remarkVisible = false"
              @submitForm="remarkVisible = false"
            ></Dialog>
            <!-- 导入弹窗 -->
            <el-dialog title="上传文件" :visible.sync="uploadDialogVisible" width="35%">
              <el-upload class="upload-demo" style="text-align: center" action="" :multiple="false" :limit="1" drag :before-upload="handleFileProgress">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传excel文件 xls xlsx csv格式</div>
                <div slot="tip" class="el-upload__tip" style="color: #409eff" v-show="!!fileName">{{ '当前选择的文件：' + fileName }}</div>
              </el-upload>
              <span slot="footer" class="dialog-footer">
                <el-button @click="uploadDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="leadingIn">确定上传</el-button>
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOrdinaryReportList,
  addOrdinaryReport,
  uploadOrdinaryReport,
  viewOrdinaryReport,
  editOrdinaryReport,
  delOrdinaryReport,
  getDutyList,
  getAdminCheckList,
  getUserNicks
} from '@/api/ordinary_report.js';
import { getUserListApi } from '@/api/testAnalysis.js';
import Pagination from '@/components/pagination/index';
import FilterCommon from '../../common/Filter';
import Dialog from '../../common/Dialog/index.vue';
import dayjs from 'dayjs'

export default {
  components: { Pagination, Dialog, FilterCommon },
  data() {
    return {
      userNicks:[],
      page: 1,
      limit: 10,
      total: 0,
      listLoading: false,
      dialogTitle: '新增',
      dialogVisible: false,
      workId: '',
      visible: false,
      uploadDialogVisible: false,
      uploadFile: {},
      fileName: '',
      remarkVisible: false,
      showSwiper: false,
      tableData: [],
      dutyOption: [],
      remarkOption: [],
      adminList: [],
      adminCheckList: [],
      sortOption: [{
        label: '有效会话量',
        value: 'effective_chat_number'
      }, {
        label: '评价人数',
        value: 'comment_number'
      }, {
        label: '满意度',
        value: 'satisfaction'
      }, {
        label: '回复时效',
        value: 'reaction'
      }],
      rules: {
        duty_type: [
          { required: true, message: "请选择班次", trigger: ['blur', 'change'] }
        ],
        nickname: [{ required: true, message: "请输入昵称", trigger: ['blur','change'] }],
        created_date: [{ required: true, message: "请选择提交时间", trigger: ['blur', 'change'] }],
        qualification_wrong_number: [{ required: true, message: "请输入质检出错量", trigger: ['blur', 'change'] }],
        qualification_test_number: [{ required: true, message: "请输入质检抽取量", trigger: ['blur', 'change'] }],
        qualification_admin_id: [{ required: true, message: "请选择质检人", trigger: ['blur', 'change'] }]
      },
      searchParams: {
        page: 1,
        limit: 10,
        start_date: dayjs(new Date()).format('YYYY-MM-DD'),
        end_date: dayjs(new Date()).format('YYYY-MM-DD')
      },
      remarkModel: [{
        type: 'el-input-textarea',
        label: '备注',
        prop: 'remark_text',
        maxlength: 200,
        showWordLimit: true,
        autoSize: { minRows: 3, maxRows: 6 }
      }, {
        type: 'el-image-swiper',
        label: '图片',
        prop: 'remark_img',
        showPagination: true
      }]
    };
  },
  computed: {
    filterModel() {
      return [{
        span: 6,
        type: 'date-picker',
        label: '提交时间：',
        key: 'date',
        dateType: false,
        empty: false,
        pick: true,
        showDefault: true
      },
      {
        type: 'select',
        label: '班次：',
        key: 'duty_type',
        placeholder: '请选择',
        span: 4,
        clearable: true,
        options: this.dutyOption,
      },
      {
        type: 'select',
        label: '普客客服：',
        key: 'admin_id',
        placeholder: '请选择',
        isMultiple: true,
        span: 4,
        options: this.adminList,
      },
      {
        type: 'select',
        label: '账号昵称：',
        key: 'nickname',
        placeholder: '请选择',
        span: 4,
        options: this.userNicks,
      },
      {
        type: 'select',
        label: '有无备注',
        key: 'remark',
        placeholder: '请选择',
        span: 4,
        clearable: true,
        options: this.remarkOption,
      }]
    },
    dialogModel() {
      if (this.dialogTitle === '新增') {
        return [{
          type: 'el-select',
          label: '班次',
          prop: 'duty_type',
          clearable: true,
          options: this.dutyOption,
        }, 
        {
          type: 'el-select',
          label: '昵称：',
          prop: 'nickname',
          placeholder: '请选择',
          isMultiple: true,
          span: 4,
          options: this.userNicks,
        },
      ]
      } else {
        return [{
          type: 'el-date-picker',
          label: '提交时间',
          prop: 'created_date',
          dateType: 'date',
          format: 'yyyy-MM-dd'
        },
        {
          type: 'el-select',
          label: '班次',
          prop: 'duty_type',
          clearable: true,
          options: this.dutyOption,
        }, {
          type: 'el-input',
          label: '昵称',
          prop: 'nickname',
          placeholder: '请输入',
        }, {
          type: 'el-input',
          label: '质检出错量',
          prop: 'qualification_wrong_number',
        }, {
          type: 'el-input',
          label: '质检抽检量',
          prop: 'qualification_test_number',
        }, {
          type: 'el-select',
          label: '质检人',
          prop: 'qualification_admin_id',
          options: this.adminCheckList
        }, 
        // {
        //   type: 'el-input-textarea',
        //   label: '备注',
        //   prop: 'remark_text',
        //   maxlength: 200,
        //   showWordLimit: true,
        //   autoSize: { minRows: 3, maxRows: 6 }
        // }, 
        {
          type: 'el-upload-image-list',
          label: '上传图片',
          prop: 'remark_img_list',
          tips: '一次最多上传8张图片',
          maximum: 8
        }]
      }
    }
  },
  created() {
    this.getTableList();
    this.getDutyList()
    this.getAdminList()
    this.getAdminCheckList()
    this.getUserNicks()
  },
  methods: {
    // 获取账号昵称
    async getUserNicks() {
      const r = await getUserNicks()
      this.userNicks = [...r.data.data].map(v=>{
        return {
          name:v.nickname,
          value:v.nickname
        }
      })
    },
    // 获取table列表
    async getTableList() {
      const r = await getOrdinaryReportList(this.searchParams)
      if (r.data.code != 200) {
        this.$message.error(r.data.message);
        return
      }
      this.tableData = r.data.data.data
      this.total = r.data.data.total
    },
    // 获取班次option
    async getDutyList() {
      const r = await getDutyList()
      this.dutyOption = [...r.data.data.duty]
      this.remarkOption = [...r.data.data.remark]
    },
    // 获取工单客服option
    async getAdminList() {
      const r = await getUserListApi()
      this.adminList = [...r.data.data]
    },
    // 获取质检客服列表
    async getAdminCheckList() {
      const r = await getAdminCheckList()
      this.adminCheckList = [...r.data.data]
    },
    // 搜索
    search(e) {
      if (!e.start_date) {
        Object.assign(e, {
          start_date: dayjs(new Date()).format('YYYY-MM-DD')
        })
      }
      if (!e.end_date) {
        Object.assign(e, {
          end_date: dayjs(new Date()).format('YYYY-MM-DD')
        })
      }
      this.searchParams = Object.assign(this.searchParams, e)
      delete this.searchParams.date
      this.getTableList();
    },
    // 重置
    reset() {
      this.searchParams = {
        page: 1,
        limit: 10,
        start_date: dayjs(new Date()).format('YYYY-MM-DD'),
        end_date: dayjs(new Date()).format('YYYY-MM-DD')
      }
      this.getTableList();
    },
    // 提交新增、编辑表单
    async handleSubmit(form) {
      if (form.remark_img_list && form.remark_img_list.length > 8) {
        this.$message.error('一次最多上传8张图片');
        return
      }
      if (form.remark_img_list && form.remark_img_list.length > 0) {
        form.remark_img = form.remark_img_list.map(item => {
          return item.url
        })
      } else {
        form.remark_img = []
      }
      let r = {}
      if (this.dialogTitle == '新增') {
        r = await addOrdinaryReport({
          id: form.id,
          duty_type: form.duty_type,
          nickname: form.nickname
        })
      } else {
        r = await editOrdinaryReport({
          id: form.id,
          created_date: form.created_date,
          nickname: form.nickname,
          duty_type:form.duty_type,
          qualification_wrong_number: form.qualification_wrong_number,
          qualification_test_number: form.qualification_test_number,
          qualification_admin_id: form.qualification_admin_id,
          remark_text: form.remark_text,
          remark_img: form.remark_img
        })
      }
      if (r.data.code != 200) {
        this.$message.error(r.data.message);
        return
      }
      const hide_page = localStorage.getItem('hide_page')
      if (hide_page == '1') {
        setTimeout(() => {
          localStorage.setItem('hide_page', '0')
          location.reload()
        }, 1000)
      }
      this.getTableList()
      this.$message.success('操作成功！');
      this.dialogVisible = false
    },
    // 点击添加
    add() {
      this.dialogTitle = '新增'
      this.dialogVisible = true
      this.$refs.dialog.editForm({})
    },
    // 点击导出
    async exp(e) {
      if (!e.start_date) {
        Object.assign(e, {
          start_date: dayjs(new Date()).format('YYYY-MM-DD')
        })
      }
      if (!e.end_date) {
        Object.assign(e, {
          end_date: dayjs(new Date()).format('YYYY-MM-DD')
        })
      }
      let searchParams = { ...e }
      searchParams.is_export = 1
      delete searchParams.date
      const r = await getOrdinaryReportList(searchParams)
      if (r.data.code != 200) {
        this.$message.error(r.data.message);
        return
      }
      let dataList = r.data.data.data
      if (dataList.length == 0) {
        this.$message.error("导出数据为空");
        return;
      }
      require.ensure([], () => {
        let {
          export_json_to_excel
        } = require('@/assets/js/Export2Excel');
        let title = "普客工作汇报";
        let tHeader = ['班次', '提交时间', '普客客服', '账号昵称', '有效会话量', '评价人数', '满意度', '回复时效', '质检出错量', '质检抽取量', '质检人'];
        let filterVal = ["duty_type_name",
          "created_date",
          "admin_name",
          "nickname",
          "effective_chat_number",
          "comment_number",
          "satisfaction",
          "reaction",
          "qualification_wrong_number",
          "qualification_test_number",
          "qualification_admin_name"];
        let data = this.formatJson(filterVal, dataList);
        export_json_to_excel(tHeader, data, title);
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        }),
      );
    },
    // 点击查看
    async examine(row) {
      this.remarkVisible = true
      this.$refs.remarkDialog.setForm({
        remark_text: row.remark_text,
        remark_img: row.remark_img
      })
    },
    // 点击编辑
    edit(row) {
      this.dialogTitle = '编辑'
      this.dialogVisible = true
      row.remark_img_list = row.remark_img.map(item => {
        return {
          url: item
        }
      })
      this.$refs.dialog.setForm(row)
    },
    // 点击删除
    async del(row) {
      const r = await delOrdinaryReport(row.id)
      row.deleteVisible = false
      if (r.data.code != 200) {
        this.$message.error(r.data.message);
        return
      }
      this.$message.success('删除成功！');
      this.getTableList()
    },
    closeDialog() {
      this.dialogVisible = false
      this.formData.nickname  = []
    },
    async handleTop(id) {
      const r = await normalAnalysisTopApi(id)
      this.getTableList()
    },
    async handleTag(id) {
      const r = await normalAnalysisTagApi(id)
      this.getTableList()
    },
    // 被标记的行背景为粉红色
    tableRowClassName({ row }) {
      if (row.is_tag) {
        return 'warning-row'
      }
      return ''
    },
    // 显示工单详情
    showDetail(workId) {
      this.$refs.worksnDetail.changeVisible(true, workId)
    },
    cancelDrawer() {
      this.$refs.drawer.closeDrawer();
    },
    // 处理翻页
    handlePagination(obj) {
      this.searchParams = Object.assign(this.searchParams, {
        page: obj.page,
        limit: obj.limit
      })
      this.getTableList()
    },
    handleFileProgress(file) {
      this.fileName = file.name;
      this.uploadFile = file
      return false
    },
    // 点击导入
    handleClickLeadIn() {
      this.uploadFile = ''
      this.fileName = ''
      this.uploadDialogVisible = true
    },
    async leadingIn() {
      this.listLoading = true;
      const formData = new FormData();
      formData.append('excel_file', this.uploadFile);
      const { data } = await uploadOrdinaryReport(formData);
      this.uploadDialogVisible = false
      this.listLoading = false;
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('上传成功');
      this.getTableList()
    },
  }
};

</script>

<style>
</style>